import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { WalletContainer } from "../../components/WalletContainer/WalletContainer";

const WalletScreen = () => {
  return (
    <ScreenLayout>
      <WalletContainer />
    </ScreenLayout>
  );
};

export default WalletScreen;
